/* global axios */
import ApiClient from '../ApiClient';

// T-284 — marcar, desmarcar e confirmar um contato como spam.
//
// O recurso é o CONTATO, e não a conversa: a marcação espelha para toda a equipe, que foi o
// pedido da Tamara ("não pode ficar só na minha conta").
class SpamAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  // estado: 'nao' | 'marcado' | 'confirmado'
  definir(contactId, estado) {
    return axios.post(`${this.url}/${contactId}/fandata_spam`, { estado });
  }
}

export default new SpamAPI();
